import { useTranslation } from 'react-i18next';

import { cn } from '~/utils/cn';

interface EnrichmentFailedBadgeProps {
  className?: string;
}

/** Error pill for a product the enrichment-status API reported as
 *  `enriched: false`. Shared by the products table and the grid tiles so the two
 *  views can never disagree about which rows are flagged. Callers gate on an
 *  explicit `false` — this component never decides visibility itself. */
export function EnrichmentFailedBadge({ className }: EnrichmentFailedBadgeProps) {
  const { t } = useTranslation('catalog-operations');
  const label = t('products.enrichmentFailed');
  return (
    <span
      data-testid="enrichment-failed-badge"
      title={t('products.enrichmentFailedTooltip')}
      className={cn(
        'bg-error-50 text-error inline-flex items-center rounded-md px-1.5 py-0.5 text-[10px] font-semibold whitespace-nowrap',
        className,
      )}
    >
      {label}
    </span>
  );
}
